/** コンポーザーが送信を所有するチャットキー。`null` は未保存の新規チャット下書きを表す。 */
export type SendOwnerKey = string | null;

export interface SendOwnership {
	key: SendOwnerKey;
	readonly token: object;
}

/**
 * チャットごとに実行中の POST を一つだけ管理する。`null` の下書きも含む。
 * 新規チャット作成後は `rebind` でキーを移し、下書き中に取得した所有権を引き継ぐ。
 */
export class SendOwnershipRegistry {
	private readonly owners = new Map<SendOwnerKey, object>();

	/** 指定チャットの送信権を取得する。既に送信中なら null を返す。 */
	acquire(key: SendOwnerKey): SendOwnership | null {
		if (this.owners.has(key)) return null;
		const ownership: SendOwnership = { key, token: {} };
		this.owners.set(key, ownership.token);
		return ownership;
	}

	/** 取得済みの送信権を別チャットへ移し、同じ飛行中処理として扱う。 */
	rebind(ownership: SendOwnership, key: SendOwnerKey): boolean {
		if (ownership.key === key) return this.isOwner(ownership);
		if (!this.isOwner(ownership) || this.owners.has(key)) return false;
		this.owners.delete(ownership.key);
		this.owners.set(key, ownership.token);
		ownership.key = key;
		return true;
	}

	/** 送信権が現在も指定の所有者に属しているかを確認する。 */
	isOwner(ownership: SendOwnership): boolean {
		return this.owners.get(ownership.key) === ownership.token;
	}

	/** 指定の送信権だけを解放する。後続の所有者には影響しない。 */
	release(ownership: SendOwnership): void {
		if (this.isOwner(ownership)) this.owners.delete(ownership.key);
	}
}
